module.exports = __webpack_public_path__ + "static/media/img1.d7e0e683.png";